import React, { useState, useRef, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core";
import appStyle from "assets/jss/components/appStyle";
import cx from "classnames";
import Sidebar from "./layout/Sidebar";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import Main from "./layout/Main";
import AppRoutes from "routes/AppRoutes";
import { useTheme } from "@material-ui/core/styles";
import { CheckInternetConnection } from "@totalsoft/rocket-webapp-components-deprecated";
import UserDataProvider from "providers/UserDataProvider";
import NotificationProvider from "./NotificationProvider";
import { env } from "utils/env";

const useStyles = makeStyles(appStyle);

function App(props) {
  const mainPanelRef = useRef();
  const classes = useStyles();
  const { location } = props;
  const theme = useTheme();
  const { logo, miniLogo } = theme;

  const [mobileOpen, setMobileOpen] = useState(false);
  const [miniActive, setMiniActive] = useState(false);

  const handleDrawerToggle = useCallback(() => {
    setMobileOpen(!mobileOpen);
  }, [mobileOpen]);

  const sidebarMinimize = useCallback(() => {
    setMiniActive(!miniActive);
  }, [miniActive]);

  useEffect(() => {
    mainPanelRef.current.scrollTop = 0;
  }, [location.pathname]);

  const mainPanel = classes.mainPanel + " " + cx({ [classes.mainPanelSidebarMini]: miniActive });

  return (
    <div className={classes.wrapper}>
      {env.REACT_APP_USE_CIAM?.toLowerCase() !== "true" && (
        <>
          <CheckInternetConnection />
          <UserDataProvider />
          <NotificationProvider />
        </>
      )}
      <Sidebar
        logo={miniActive ? miniLogo || logo : logo}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        miniActive={miniActive}
      />
      <div className={mainPanel} ref={mainPanelRef}>
        <Header sidebarMinimize={sidebarMinimize} miniActive={miniActive} handleDrawerToggle={handleDrawerToggle} />
        <Main>
          <AppRoutes />
        </Main>
        <Footer fluid />
      </div>
    </div>
  );
}

App.propTypes = {
  location: PropTypes.object.isRequired,
};

export default App;
